import { useState } from 'react';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { TextField } from '@mui/material';

/*  InputField
 *  @params id            string    identificador input
 *  @params label         string    label input
 *  @params value         any type  value input
 *  @params disabled      bool      disabled input
 *  @params error         bool      enable class error
 *  @params helperText    string    helper text
 *  @params onChange      function  function change
 *  @params InputProps     Object
 */

const InputPassword = ({
  id,
  disabled,
  label,
  name,
  placeholder,
  value,
  error,
  variant = 'standard',
  helperText,
  onChange,
  onBlur,
  onKeyPress,
  autoFocus,
  inputRef
}) => {
  const [values, setValues] = useState({ showPassword: false });

  const handleClickShowPassword = () => {
    setValues({ showPassword: !values.showPassword });
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  return (
    <TextField
      fullWidth
      id={id}
      name={name}
      label={label}
      variant={variant}
      value={value}
      error={error}
      helperText={helperText}
      onChange={onChange}
      onBlur={onBlur}
      disabled={disabled}
      onKeyPress={onKeyPress}
      autoFocus={autoFocus}
      inputRef={inputRef}
      type={values.showPassword ? 'text' : 'password'}
      InputProps={{
        endAdornment: (
          <InputAdornment position='end'>
            <IconButton
              aria-label='toggle password visibility'
              onClick={handleClickShowPassword}
              onMouseDown={handleMouseDownPassword}
            >
              <FontAwesomeIcon icon={values.showPassword ? 'eye' : 'eye-slash'} />
            </IconButton>
          </InputAdornment>
        )
      }}
    />
  );
};

export default InputPassword;
